import { render, staticRenderFns } from "./AccountingAccount.vue?vue&type=template&id=049298c1&"
import script from "./AccountingAccount.vue?vue&type=script&lang=js&"
export * from "./AccountingAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports